export function stringToHslColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = hash % 360;
    return `hsl(${h}, 70%, 80%)`; // Adjust saturation and lightness as needed
}

export function getInitials(firstName, lastName) {
    const firstInitial = firstName ? firstName[0].toUpperCase() : "";
    const lastInitial = lastName ? lastName[0].toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
}

export function getDarkerHslColor(name) {
    const hslColor = stringToHslColor(name);
    const [h, s, l] = hslColor.match(/\d+/g).map(Number);
    // Reduce the lightness by a certain amount (e.g., 20%) to make the color darker
    const darkerL = Math.max(l - 20, 0); // Ensure lightness doesn't go below 0
    return `hsl(${h}, ${s}%, ${darkerL}%)`;
}

export function stripHtmlTags(htmlString) {
    return htmlString?.replace(/<\/?[^>]+(>|$)/g, "");
};

export function logout(navigate) {
    // Clear user-related data (localStorage, sessionStorage, etc.)
    localStorage.removeItem("userData");
    // Redirect to the login page
    if (navigate) {
        window.location.href = "/login";
    }
}